// Produktet Love/Couple tani ruhen në Supabase database
export const productsCouple = [];
